// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import XRegExp from 'xregexp'
import { coordsDMS } from 'helpers/regex'
import { isWithinMinMaxVals } from 'validators/common'

import {
  LATITUDE_DEGREE_RANGE,
  LATITUDE_INVALID_FORMAT,
  LATITUDE_OUTSIDE_BOUNDS,
  MINUTES_RANGE,
  SECONDS_RANGE,
  REQUIRED,
} from 'errors'

// validate lat format and value
const validateLatitude = (value, error, notRequired) => {
  const dLat = XRegExp.exec(value, coordsDMS)?.groups || null

  // if the value's not required and the value's an empty string,
  // don't run any validation checks
  if (notRequired && !value) {
    return
  }

  if (!value) {
    error.latitude = REQUIRED
  } else if (
    // regex didn't match
    dLat === null ||
    // value passed regex but had both prefix and suffix (not sure how to control this in regex)
    (dLat.prefix && dLat.suffix)
  ) {
    error.latitude = LATITUDE_INVALID_FORMAT
  } else if (dLat.suffix !== 'N' && dLat.suffix !== 'S') {
    error.latitude = 'Latitude direction can only be N or S.'
  } else if (!isWithinMinMaxVals(dLat.degrees, -90, 90)) {
    error.latitude = LATITUDE_DEGREE_RANGE

  // because of formatting validation above, we can't actually
  // have mins that are less than 0.
  } else if (!isWithinMinMaxVals(dLat.minutes, 0, 59)) {
    error.latitude = MINUTES_RANGE

  // because of formatting validation above, we can't actually
  // have seconds that are less than 0.
  } else if (!isWithinMinMaxVals(`${dLat.seconds}.${dLat.milliseconds}`, 0, 59.99)) {
    error.latitude = SECONDS_RANGE

  // checks to see if min/seconds/milli are > 0 when deg is -90/90.
  } else if ((
    parseInt(dLat.degrees) === 90 ||
    parseInt(dLat.degrees) === -90
  ) && (
    dLat.minutes > 0 ||
    dLat.seconds > 0 ||
    dLat.milliseconds > 0
  )) {
    error.latitude = LATITUDE_OUTSIDE_BOUNDS
  }
}

export default validateLatitude
